import { IApiManufactory, accountService } from '@tap/data-providers';
import { useFetchData } from '@tap/mui-ui';

export type ExtSector = {
    manufactory: string,
    departmentId: number,
    name: string,
    fullName: string,
}

export type UseDepartmentState = {
    manufactoryList: IApiManufactory[],
    sectorList: ExtSector[],
    isLoading: boolean,
}

export const useDepartment = (): UseDepartmentState => {
    const [_sourceDataState, sourceData, isLoading] = useFetchData(async () => {
        const manufactoryList = await accountService.getDepartmentListByRole('D');
        const sectorList = manufactoryList.flatMap(m => m.sectors.map(s => ({
            ...s,
            manufactory: m.name,
            departmentId: s.id,
            fullName: `${m.name}.${s.name}`,
        })));

        return { manufactoryList, sectorList };
    }, []);

    return {
        manufactoryList: sourceData?.manufactoryList || [],
        sectorList: sourceData?.sectorList || [],
        isLoading,
    };
}